<template>
    <div class="stf-sticky-banners-wrapper">
        <!-- Teleport target for SummaryBanner -->
        <div id="summary-banner-target"></div>
        <NotificationBanner />
    </div>
</template>

<script setup lang="ts">
import NotificationBanner from './NotificationBanner.vue';
</script>

<style scoped>
.stf-sticky-banners-wrapper {
    position: fixed;
    top: 72px; /* Height of the navbar */
    left: 0;
    right: 0;
    width: 100%;
    z-index: 98; /* Below navbar (102) but above other content */
    display: flex;
    flex-direction: column;
}

/* Mobile styles */
@media (max-width: 768px) {
    .stf-sticky-banners-wrapper {
        top: 65px; /* Mobile navbar height */
    }
}
</style> 